var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.707 2.42706C12.5194 2.23959 12.2651 2.13428 12 2.13428C11.7348 2.13428 11.4805 2.23959 11.293 2.42706L4.29296 9.42706L2.29296 11.4271C2.19745 11.5193 2.12127 11.6297 2.06886 11.7517C2.01645 11.8737 1.98886 12.0049 1.98771 12.1377C1.98655 12.2704 2.01186 12.4021 2.06214 12.525C2.11242 12.6479 2.18667 12.7596 2.28056 12.8535C2.37446 12.9474 2.48611 13.0216 2.60901 13.0719C2.7319 13.1222 2.86358 13.1475 2.99636 13.1463C3.12914 13.1452 3.26036 13.1176 3.38236 13.0652C3.50437 13.0128 3.61471 12.9366 3.70696 12.8411L3.99996 12.5481V19.1341C3.99996 19.9297 4.31603 20.6928 4.87864 21.2554C5.44125 21.818 6.20431 22.1341 6.99996 22.1341H17C17.7956 22.1341 18.5587 21.818 19.1213 21.2554C19.6839 20.6928 20 19.9297 20 19.1341V12.5481L20.293 12.8411C20.4816 13.0232 20.7342 13.124 20.9964 13.1217C21.2586 13.1195 21.5094 13.0143 21.6948 12.8289C21.8802 12.6435 21.9854 12.3927 21.9876 12.1305C21.9899 11.8683 21.8891 11.6157 21.707 11.4271L12.707 2.42706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuHome);
export default __webpack_public_path__ + "static/media/icon_menu_home.4a28c21a7e897d9837a2b9fea9ed4f14.svg";
export { ForwardRef as ReactComponent };